module.exports = __webpack_public_path__ + "static/sec3-bg-2a6bce36411b3e9b76f61d90ddefd846.jpg";